const getTargetMode = (service) => {
  const name = (service?.name || "").toLowerCase();
  if (!name) return "post";
  if (name.includes("tiktok")) return name.includes("followers") ? "tiktok-profile" : "tiktok-video";

  const profileKeywords = ["followers", "subscriber", "subscribers", "page likes", "page like"];
  const postKeywords = ["views", "likes", "shares", "saves", "reels", "reactions", "watch", "video", "story"];
  if (profileKeywords.some((keyword) => name.includes(keyword))) return "profile";
  if (postKeywords.some((keyword) => name.includes(keyword))) return "post";
  return "post";
};

const isUsernameOnly = (value) => {
  const trimmed = value.trim();
  if (!trimmed || trimmed.includes("http://") || trimmed.includes("https://")) return false;
  return /^@?[a-zA-Z0-9._-]{2,30}$/.test(trimmed);
};

const isProfileUrl = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return false;
  const withoutProtocol = trimmed.replace(/^https?:\/\//i, "");
  const domainPattern = /^(?:www\.)?(?:instagram\.com|facebook\.com|fb\.com|tiktok\.com|x\.com|twitter\.com|youtube\.com)(?:\/[^\s]*)?$/i;
  if (!domainPattern.test(withoutProtocol)) return false;
  return !/(\/p\/|\/tv\/|\/video|\/reel|\/reels|\/post|\/story|\/watch|\/short|\/clips|\/photos?\/|\?.*(v=|id=))/i.test(withoutProtocol.toLowerCase());
};

const isPostUrl = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return false;
  const tiktokShortUrl = /^https:\/\/(?:vt|vm)\.tiktok\.com\/[^\s/?]+\/?(?:\?[^\s]*)?$/i;
  const tiktokVideoUrl = /^https:\/\/(?:www\.)?tiktok\.com\/@[^/\s]+\/video\/\d+\/?(?:\?[^\s]*)?$/i;
  if (tiktokShortUrl.test(trimmed) || tiktokVideoUrl.test(trimmed)) return true;
  const withoutProtocol = trimmed.replace(/^https?:\/\//i, "");
  if (isProfileUrl(trimmed)) return false;
  if (!/^(?:www\.)?([a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s]*)?$/i.test(withoutProtocol)) return false;
  return /(\/p\/|\/tv\/|\/video|\/reel|\/reels|\/post|\/story|\/watch|\/short|\/clips|\/photos?\/|[?&](v=|id=))/i.test(trimmed.toLowerCase());
};

const isTikTokVideoUrl = (value) => {
  const trimmed = value.trim();
  return /^https:\/\/(?:vt|vm)\.tiktok\.com\/[^\s/?]+\/?(?:\?[^\s]*)?$/i.test(trimmed)
    || /^https:\/\/(?:www\.)?tiktok\.com\/@[^/\s]+\/video\/\d+\/?(?:\?[^\s]*)?$/i.test(trimmed);
};

const isTikTokProfileUrl = (value) => /^https:\/\/(?:www\.)?tiktok\.com\/@[a-zA-Z0-9._-]{2,30}\/?(?:\?[^\s]*)?$/i.test(value.trim());

export const normalizeTarget = (value) => {
  const match = value.trim().match(/https?:\/\/[^\s<>"']+/i);
  return (match ? match[0] : value.trim()).replace(/[.,;:!?)}]+$/, "");
};

export const validateTarget = (service, value) => {
  const mode = getTargetMode(service);
  const trimmed = value.trim();
  if (!trimmed) return "Sila masukkan target.";
  if (mode === "tiktok-video") return isTikTokVideoUrl(trimmed) ? "" : "Sila masukkan link video TikTok yang sah.";
  if (mode === "tiktok-profile") return isUsernameOnly(trimmed) || isTikTokProfileUrl(trimmed) ? "" : "Sila masukkan link profile TikTok atau username yang sah.";
  if (mode === "post") {
    if (isUsernameOnly(trimmed) || isProfileUrl(trimmed)) return "Untuk servis post/video, sila masukkan link post/video, bukan username atau link profile.";
    return isPostUrl(trimmed) ? "" : "Untuk servis post/video, sila masukkan link post/video yang sah.";
  }
  if (isPostUrl(trimmed)) return "Untuk servis followers, sila masukkan username atau link profile, bukan link post/video.";
  return isUsernameOnly(trimmed) || isProfileUrl(trimmed) ? "" : "Untuk servis followers, sila masukkan username atau link profile yang sah.";
};